import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { Store } from '@ngxs/store';

import { BaseMenuItem, TicketItem } from 'src/app/models';
import { TicketProvider } from 'src/app/providers';
import { TicketsStateSelectors } from 'src/app/store/tickets/tickets.selectors';

@Component({
  selector: 'pos-open-text-modifier-modal',
  templateUrl: './open-text-modifier.modal.html',
  styleUrls: ['./open-text-modifier.modal.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OpenTextModifierModal {
  @Input() selectedTicketItem: TicketItem;
  @Input() modifierColor: string | null = null;

  private readonly controls = {
    description: new FormControl(undefined, [
      Validators.required,
      Validators.maxLength(50)
    ]),
    price: new FormControl(undefined)
  };

  form = new FormGroup(this.controls);

  constructor(
    private readonly modalController: ModalController,
    private readonly ticketProvider: TicketProvider,
    private readonly store: Store
  ) {}

  onSaveNotes() {
    const value = this.form.value;
    if (!value.price) {
      value.price = 0;
    }
    const baseMenuItem = {
      name: value.description,
      price: value.price,
      modifier_color: this.modifierColor
    } as BaseMenuItem;

    const selectedNormalizedTicket = this.store.selectSnapshot(
      TicketsStateSelectors.normalizedTicket
    );

    this.ticketProvider.ticketItemAddingHandler({
      menuItem: baseMenuItem,
      ticket_uuid: selectedNormalizedTicket?.device_ticket_uuid,
      ticket_item_uuid: this.selectedTicketItem.device_ticket_item_uuid
    });
    this.onCloseModal();
  }

  onCloseModal() {
    this.modalController.dismiss();
  }
}
